import { WidgetStrategyWithConfig } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { Outliers } from 'widgets/outliers/components/Outliers';
import {
    initialOutliersConfigState,
    OutliersConfigState,
} from 'widgets/outliers/store/config/OutliersConfigState';

import { getOutliersRequiredOrderColumns } from 'widgets/outliers/data/orderColumns';
import { buildOutliersConfigSlice } from 'widgets/outliers/store/config/configSlice';
import State from 'store/State';
import { outliersDescription } from 'widgets/outliers/components/description/outliersDescription';
import { selectIsFeatureEnabled } from 'app/store/featureToggles/selectors';
import { WellKnownFeatureToggleKeys } from 'app/store/featureToggles/FeatureTogglesState';

const {
    selectors: { selectConfigState },
} = buildOutliersConfigSlice();

export const outliersStrategy: WidgetStrategyWithConfig<OutliersConfigState> = {
    title: 'Outliers',
    reactComponentType: Outliers,
    categories: [WidgetCategory.PORTFOLIO],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.PortfolioOfOrders,
    initialConfigState: initialOutliersConfigState,
    supportedHosts: ['layout'],
    getRequiredOrderColumns,
    checkOrderColumnsOnConfigChange: true,
    description: outliersDescription,
};

function getRequiredOrderColumns(state: State, widgetId: string) {
    const config = selectConfigState(state, widgetId);
    const isLastPriceEnabled = selectIsFeatureEnabled(
        state,
        WellKnownFeatureToggleKeys.LastPriceEnabled
    );

    return getOutliersRequiredOrderColumns(config, isLastPriceEnabled);
}
